import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Cart from '../views/Cart.vue'
// const Home = () => import('../views/Home.vue')

import PumpReport from '../components/PumpReport.vue'
// const PumpReport = () => import('../components/PumpReport.vue')
import Login from '../components/Login.vue'

import i18n from '../i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    path: '/:lang',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/',
        name: 'Login',
        component: Login
      },{
        path: 'cart',
        name: 'Cart',
        component: Cart
      },
      {
        path: 'find',
        name: 'home',
        component: Home
      },
      {
        path: 'pump_report/:pumpid/:idpump_perf/:stage/:flow/:head/:unit_flow/:unit_head/:idmotor/:frequency/',
        name: 'pump_report',
        component: PumpReport,
        props: true
      }
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
